// @ts-ignore
import { initSinglePageNavigation } from './perks_navbar.js';
import { initReviewsForm } from './review_form.js';
import { initReviewsHandler } from './reviews_handler.js';
import { initNavigationMenu } from './util_navigation_menu.js';

function initSendInstructionByEmail(btn: HTMLButtonElement, popup:HTMLElement) {
    let buttonLoadingState = false;
    let buttonCurrentContent = btn.innerHTML;

    const sendEmail = async () => {
        const btnText = btn.innerHTML;
        const url = btn.getAttribute('data-email-url') as string;
        const perks_id = btn.getAttribute('data-post-id') as string;
        
        const formData = new FormData();
        formData.append('action', 'pc_sp_send_perks_instructions_email');
        formData.append('perks_id', perks_id);

        btn.innerHTML = 'Sending...';
        const response = await fetch(url, {
            method: 'POST',
            body: formData
        });
        btn.innerHTML = btnText;
        if (!response.ok) {
            const errorMessage = await response.text();
            console.error('Error sending email:', errorMessage);
            throw new Error(errorMessage);
        }
    }

    const showEmailSuccessAlert = () => {
        const alertSuccess = popup.querySelector('.alert_email_success') as HTMLElement;
        if (alertSuccess) {
            alertSuccess.classList.remove('hidden');
            setTimeout(() => {
                alertSuccess.classList.add('hidden');
            }, 5000); // Hide after 5 seconds
        }
    }

    const showEmailErrorAlert = () => {
        const alertError = popup.querySelector('.alert_email_failed') as HTMLElement;
        if (alertError) {
            alertError.classList.remove('hidden');
            setTimeout(() => {
                alertError.classList.add('hidden');
            }, 5000); // Hide after 5 seconds
        }
    }

    const handleButtonClick = async (e: MouseEvent) => {
        e.preventDefault();
        if (buttonLoadingState) return;

        buttonLoadingState = true;

        const secondDiv = btn.querySelector('div:nth-child(2)');
        if (secondDiv) {
            secondDiv.innerHTML = 'Sending...';
        }
        
        try {
            await sendEmail();
            btn.innerHTML = buttonCurrentContent;
            showEmailSuccessAlert();
        } catch (error) {
            console.error('Error sending email:', error);
            btn.innerHTML = buttonCurrentContent;
            showEmailErrorAlert();
        } finally {
            buttonLoadingState = false;
        }
    }

    btn.addEventListener('click', handleButtonClick);
}

function initSinglePerksPopup(){
    const popup = document.querySelector('.pc_sp_claim_deal_popup') as HTMLElement;
    if (!popup) return;
    const claimDealBtn = document.querySelector('button.pc_sp_single_item_claim_button') as HTMLElement;
    if (!claimDealBtn) return;

    const closeButton = popup.querySelector('.pc_sp_claim_deal_popup_close_button');
    const sendInstructionMailBtn = popup.querySelector('.pc_sp_button_send_instr_email') as HTMLElement;
    let popupOpenState = false;

    const closePopup = () => {
        if (!popupOpenState) return;
        popup.style.transition = 'opacity 0.3s ease-in-out';
        popup.style.opacity = '0';
        setTimeout(() => {
            popup.style.display = 'none';
            popup.style.opacity = '1'; // Reset opacity for next open
            popup.style.transition = ''; // Reset transition
        }, 300); // Match the transition duration
        popupOpenState = false;
    }

    const openPopup = () => {
        if (popupOpenState) return;
        popup.style.opacity = '0';
        popup.style.display = 'flex';
        setTimeout(() => {
            popup.style.transition = 'opacity 0.3s ease-in-out';
            popup.style.opacity = '1';
        }, 10); // Short delay to allow the display change to take effect
        setTimeout(() => {
            popup.style.transition = ''; // Reset transition
        }, 300); // Match the transition duration
        popupOpenState = true;
    }

    claimDealBtn.addEventListener('click', (e) => {
        e.preventDefault();
        openPopup();
    });

    if (closeButton) {
        closeButton.addEventListener('click', (e) => {
            e.preventDefault();
            closePopup();
        });
    }

    // outside click to close popup
    /*document.addEventListener('click', (e) => {
        if (!(e.target instanceof HTMLElement)) return;
        if (popupOpenState && !popup.contains(e.target) && !claimDealBtn.contains(e.target)) {
            closePopup();
        }
    });*/

    if (sendInstructionMailBtn) {
        initSendInstructionByEmail(sendInstructionMailBtn as HTMLButtonElement, popup);
    } else {
        console.error('Send instruction by email button not found');
    }
}

export default function initSinglePage(){
    initSinglePerksPopup();
    initReviewsHandler();
    initNavigationMenu();
    initSinglePageNavigation();
    initReviewsForm();
}